import React, { useRef } from "react";
import axios from "axios";
import { toast } from "react-toastify";

function LessonDeleteModal({ lessonId, closeHandler, deleteHandler }) {
    const deleteAndClose = async (id) => {
        const req = await fetch(`${process.env.REACT_APP_API_ROOT}/api/consultation/delete/${id}`, {
            method: "DELETE"
        })

        if(req.status === 200) {
            toast.success("Consultația a fost ștearsă cu succes.", { position: `top-center` })
            deleteHandler()
        } else {
            const res = await req.json()
            toast.error(`Eroare: ${res.message}`)
        }
    }

    return (
        <>
            <div className="delete-modal">
                <div
                    className="background-delete-modal"
                    onClick={closeHandler}
                >
                    <div className="wrapper-delete-modal">
                        <i
                            className="fas fa-times fa-2x close-new-form"
                            onClick={closeHandler}
                        ></i>
                        <div className="delete-modal-content">
                            <h2>Ești sigur că vrei să stergi consultația?</h2>
                            <div className="delete-modal-buttons">
                                <button
                                    className="delete-modal-btn-yes"
                                    onClick={() => deleteAndClose(lessonId)}
                                >
                                    Da
                                </button>
                                <button
                                    className="delete-modal-btn-no"
                                    onClick={closeHandler}
                                >
                                    Nu
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default LessonDeleteModal;
